// Only equal reads share an in-flight promise; completed results are never cached.
let generation = 0;
let scope = '';
const flights = new Map<string, Promise<unknown>>();
export function invalidateReadIdentity() { generation += 1; scope = ''; }
export function setReadIdentity(value: string) {
  if (value !== scope) { scope = value; generation += 1; }
}
export function readIdentity() { return generation; }
export function singleRead<T>(key: string, read: () => Promise<T>, signal?: AbortSignal): Promise<T> {
  if (signal?.aborted) return Promise.reject(new DOMException('Read cancelled', 'AbortError'));
  const identity = generation;
  const fullKey = JSON.stringify([identity, key]);
  let pending = flights.get(fullKey) as Promise<T> | undefined;
  if (!pending) {
    pending = read();
    flights.set(fullKey, pending);
    const retire = () => { if (flights.get(fullKey) === pending) flights.delete(fullKey); };
    void pending.then(retire, retire);
  }
  return pending.then(value => {
    if (signal?.aborted) throw new DOMException('Read cancelled', 'AbortError');
    if (identity !== generation) throw new Error('账号状态已变化，请刷新。');
    return structuredClone(value);
  });
}
